import { getFormattedUTCDate } from "helpers";
import { t } from "i18next";
import { CellDef, Styles } from "jspdf-autotable";
import { OrderPaymentMethod } from "modules/orders";

import { DELIVERY_STATUSES_LIST, DeliveryType } from "../../constants";
import { DriverDeliveriesListItem } from "../../financial.types";

interface getContactsProps {
  deliveries: DriverDeliveriesListItem[];
  normalFontStyles: Partial<Styles>;
}
export const getDeliveriesRows = ({
  deliveries,
  normalFontStyles
}: getContactsProps) => {
  const getDeliveryStatusLabel = (st: string) =>
    DELIVERY_STATUSES_LIST.find((status) => status.value === st)?.label ??
    t("Unknown");

  const deliveryRowStyle: Partial<Styles> = {
    valign: "middle",
    halign: "center",
    ...normalFontStyles,
    fontStyle: "normal"
  };

  const getDeliveryTypeLabel = (type: DeliveryType) => {
    switch (type) {
      case DeliveryType.ReturnDeliveryToCustomer:
        return `${t("Return Delivery")}\n`;
      case DeliveryType.ReturnPickUpFromCustomer:
        return `${t("Return pick-up")}\n`;

      default:
        return "";
    }
  };

  return deliveries.map((delivery) => {
    const orderCell: CellDef = {
      content: `${getDeliveryTypeLabel(delivery.type)}${delivery.orderId}\n${delivery.recipientFullName}\n${delivery.recipientAddress}\n${delivery.recipientPhoneNumber}`,
      styles: { ...deliveryRowStyle, halign: "left" }
    };
    const deliveryDateCell: CellDef = {
      content: getFormattedUTCDate(delivery.deliveryDate, "DD/MM/YYYY"),
      styles: deliveryRowStyle
    };

    const orderTotalCell: CellDef = {
      content: delivery.totalOrder,
      styles: deliveryRowStyle
    };

    const feesCell: CellDef = {
      content: delivery.deliveryFee,
      styles: deliveryRowStyle
    };

    const toCollectCell: CellDef = {
      content: delivery.amountCollected || delivery.amountToCollect,
      styles: {
        ...deliveryRowStyle,
        textColor: delivery.amountCollected ? "#16c350" : "#000"
      }
    };

    const toPayCell: CellDef = {
      content: delivery.amountToPay,
      styles: deliveryRowStyle
    };

    const paidCell: CellDef = {
      content: delivery.amountPaid,
      styles: {
        ...deliveryRowStyle,
        textColor: delivery.amountPaid ? "#16c350" : "#000"
      }
    };

    const paymentMethodCell: CellDef = {
      content:
        delivery.orderPaymentMethod === OrderPaymentMethod.CashOnDelivery
          ? t("Cash")
          : t("Mobile Money"),
      styles: deliveryRowStyle
    };

    const statusCell: CellDef = {
      content: t(getDeliveryStatusLabel(delivery.status)),
      styles: deliveryRowStyle
    };

    return [
      orderCell,
      deliveryDateCell,
      orderTotalCell,
      feesCell,
      toCollectCell,
      toPayCell,
      paidCell,
      paymentMethodCell,
      statusCell
    ];
  });
};
